import { render } from "./EditPRSummary.vue?vue&type=template&id=7c265411"
import script from "./EditPRSummary.vue?vue&type=script&lang=js"
export * from "./EditPRSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__